import { useState } from 'react';
import checkBankStatus from '../../../../api/bank/checkStatusAppeal';
import generateContract from '../../../../api/deals/generateContract';
import generateLink from '../../../../api/signature/generateLink';
import Button from '../../../../components/Button/Button';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import FormHeading from '../../../../components/Typography/FormHeading';
import { DEAL_STEPS, DOCUMENT_TYPES_CONTRACT } from '../../../../constants';
import { textStyles } from '../../../../constants/textStyles';
import alert from '../../../../helpers/alert';
import { SIGN_TYPES } from '../../../Public/SignDocuments';
import StepControlButtons from './StepControlButtons';

const ContractSign = ({ deal, documents, cars, onSuccess, dealStepAfterSign, update }) => {
  const [isSmsSent, setIsSmsSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendSmsForSign = async () => {
    try {
      setLoading(true);
      let contract = documents?.find((i) => i?.typeId == DOCUMENT_TYPES_CONTRACT);
      if (!contract) {
        contract = await generateContract({
          orderIds: cars?.map((i) => i?.orderId),
          chunkId: deal?.chunkId,
          dealId: deal?.id,
        });
        contract = JSON.parse(contract?.data);
      }

      console.log(contract);
      if ((!contract?.documentId && !contract?.id) || !contract?.url) {
        throw Error;
      }

      await generateLink({
        url: contract?.url,
        name: 'docs',
        typeId: DOCUMENT_TYPES_CONTRACT,
        documentId: contract?.documentId || contract?.id,
        userId: deal?.client?.id,
        dealId: deal?.id,
        signType: SIGN_TYPES.ECP,
        step: dealStepAfterSign,
      });
      setIsSmsSent(true);

      if (onSuccess) {
        onSuccess();
      } else {
        alert.success('Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾');
      }
    } catch (e) {
      console.log(e);
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐµ Ð¡ÐÐ¡ ÐºÐ»Ð¸ÐµÐ½ÑÑ');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <StepControlButtons
        dealId={deal?.id}
        nextStep={dealStepAfterSign}
        prevStep={DEAL_STEPS.SELECT_BANKS}
        update={update}
        setLoading={setLoading}
      />
      <p
        style={{
          ...textStyles.formTitle,
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° ÐºÑÐ¿Ð»Ð¸-Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸
      </p>

      <div style={{ display: 'grid', gap: '10px', justifyContent: 'flex-start' }}>
        {!isSmsSent && (
          <Button
            disabled={loading}
            text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð­Ð¦Ð"
            fill
            onClick={() => sendSmsForSign(false)}
          />
        )}
        <Button onClick={update} text="ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ" fill />
      </div>
    </div>
  );
};

export default ContractSign;
